import { render, staticRenderFns } from "./ContainerMenu.vue?vue&type=template&id=b725fdda&"
import script from "./ContainerMenu.vue?vue&type=script&lang=js&"
export * from "./ContainerMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContainerMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContainerMenu.vue"
export default component.exports